/**
 * events selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';
import get from 'lodash.get';
import keyBy from 'lodash.keyby';

interface State {
    reportsHarvestInspections: {
        [string]: Record<string, any>
    };
}

interface Props {
    eventId?: number | string;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectReportsHarvestInspections = (state: State) =>
    state.reportsHarvestInspections;
const selectEventId = (state: State, props: Props) =>
    props.eventId && `${props.eventId}`;

const selectReportsHarvestInspectionsArray = createDeepEqualSelector(
    selectReportsHarvestInspections,
    reportsHarvestInspectionsState =>
        Object.values(reportsHarvestInspectionsState)
);

const selectReportsHarvestInspection = createDeepEqualSelector(
    selectReportsHarvestInspections,
    selectEventId,
    (reportsHarvestInspectionsState, eventId) =>
        eventId && reportsHarvestInspectionsState[eventId]
);

const selectReportsHarvestInspectionEventJobs = createDeepEqualSelector(
    selectReportsHarvestInspection,
    reportsHarvestInspectionState =>
        get(reportsHarvestInspectionState, 'event.jobs')
);

const selectReportsHarvestInspectionEventJobsKeyedByJobType = createDeepEqualSelector(
    selectReportsHarvestInspectionEventJobs,
    reportsHarvestInspectionEventJobsState =>
        keyBy(reportsHarvestInspectionEventJobsState, 'jobType')
);

const makeSelectReportsHarvestInspectionJobState = (jobType: string) =>
    createDeepEqualSelector(
        selectReportsHarvestInspectionEventJobsKeyedByJobType,
        reportsHarvestInspectionEventJobsKeyedByJobTypeState =>
            get(reportsHarvestInspectionEventJobsKeyedByJobTypeState, [
                jobType,
                'jobState'
            ])
    );

const makeSelectReportsHarvestInspectionValue = (field: string) =>
    createDeepEqualSelector(
        selectReportsHarvestInspection,
        reportsHarvestInspectionState =>
            reportsHarvestInspectionState &&
            reportsHarvestInspectionState[field]
    );

export {
    selectReportsHarvestInspections,
    selectReportsHarvestInspectionsArray,
    selectReportsHarvestInspection,
    selectReportsHarvestInspectionEventJobs,
    selectReportsHarvestInspectionEventJobsKeyedByJobType,
    makeSelectReportsHarvestInspectionJobState,
    makeSelectReportsHarvestInspectionValue
};
